import React from 'react'
import img2039 from '../components/images/lmeesho.png'
const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2039} alt='meesho' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Meesho Listing Services
                    </h2>
                    <p>Elevate your Meesho presence with our expert listing services, tailored to boost your visibility and sales. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services :</h3>
                <li><b>•	Product Listing:</b>Enhance listings with precise descriptions, high-quality images, and targeted keywords for better search visibility.</li>
                <li><b>•	Advertising Campaign:</b>Run focused ad campaigns to increase product visibility and drive sales. </li>
                <li><b>•	Account Health:</b> Maintain a healthy seller account by ensuring compliance with Meesho policies. </li>
                <li><b>•	Order Processing:</b> : Efficiently manage order fulfillment from receipt to delivery. </li>
                <li><b>•	Payment Reconciliation:</b> Ensure accurate payment records and promptly resolve discrepancies. </li>
                <li><b>•	Keyword Optimization:</b> Use strategic keywords to improve search rankings and visibility. </li>
                <li><b>•	Basic Training:</b>Equip yourself with essential skills for effective account management. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to increase sales through promotions and optimized advertising.</li>
                <p>Unlock your full potential on Amazon with our expert management services. Contact E Seller Support for more information and to get started on your journey to success.</p>
            </ul>
        </>
    )
}

export default events